import Vue from 'vue';
import Router from 'vue-router';

import data from '@/assets/data';
import store from '@/store';
import Home from '@/views/Home.vue';
import NotFound from '@/views/NotFound.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        data: data.whatAbout,
        title: 'O valor do seu imposto | Oxfam Brasil',
        image: require('@/assets/images/home/img-home-andreteixeira.png'),
        description: 'Entenda o papel social dos impostos e porque uma reforma tributária justa é fundamental para reduzir as desigualdades brasileiras.',
      },
    },
    {
      path: '/do-que-estamos-falando',
      name: 'about',
      meta: {
        data: data.whatAbout,
        title: 'Do que estamos falando | O valor do seu imposto',
        image: require('@/assets/images/post/hero-doqueestamosfalando.jpg'),
        description: 'Nossa Constituição determina que o sistema tributário brasileira seja justo, cobrando mais de quem ganha mais. No entanto, o que temos hoje é um sistema que pesa muito sobre os mais pobres.',
      },
      component: () => import('@/views/Post.vue'),
    },
    {
      path: '/reforma-tributaria',
      name: 'tax-reform',
      meta: {
        data: data.taxReform,
        title: 'Reforma Tributária | O valor do seu imposto',
        image: require('@/assets/images/post/hero-reformatributaria.jpg'),
        description: 'O Brasil avançou no enfrentamento da concentração de renda nas últimas décadas, mas isso não foi suficiente para nos tirar do vergonhoso ranking mundial da desigualdade – estamos entre os 10 mais desiguais do planeta!',
      },
      component: () => import('@/views/Post.vue'),
    },
    {
      path: '/como-fizemos-as-contas',
      name: 'how-we-do-the-sum',
      meta: {
        data: data.howDoBills,
        title: 'Como fizemos as contas | O valor do seu imposto',
        image: require('@/assets/images/post/hero-comofizemosascontas.jpg'),
        description: 'Por trás dos números de nossa ferramenta O Valor do Seu Imposto, há uma base de dados inédita que elaboramos a partir da junção de dados de diferentes pesquisas e dados públicos.',
      },
      component: () => import('@/views/Post.vue'),
    },
    {
      path: '/perguntas-e-respostas',
      name: 'quastions-and-anwsers',
      meta: {
        data: data.questionsAndAnwsers,
        title: 'Perguntas & Respostas | O valor do seu imposto',
        image: require('@/assets/images/post/hero-perguntaserespostas.jpg'),
        description: 'Aqui você poderá tirar suas principais dúvidas sobre a ferramenta e sua metodologia.',
      },
      component: () => import('@/views/Post.vue'),
    },
    {
      path: '/resultado/:income',
      name: 'result',
      meta: {
        title: 'O valor do seu imposto | Oxfam Brasil',
        image: require('@/assets/images/home/img-home-andreteixeira.png'),
        description: 'Entenda o papel social dos impostos e porque uma reforma tributária justa é fundamental para reduzir as desigualdades brasileiras.',
      },
      component: () => import('@/views/Result.vue'),
    },
    {
      path: '/compartilhe',
      name: 'share',
      meta: {
        title: 'Compartilhe | O valor do seu imposto',
        image: require('@/assets/images/share-view.jpg'),
        description: 'Nosso sistema de cobranças impostos está agravando as desigualdades sociais.Além de complexo e ineficiente, ele é injusto, pesando proporcionalmente mais sobre quem ganha menos.',
      },
      component: () => import('@/components/Share.vue'),
    },
    {
      path: '/obrigado',
      name: 'share',
      meta: {
        title: 'Obrigado! | O valor do seu imposto',
        image: require('@/assets/images/share-view.jpg'),
        description: 'Nosso sistema de cobranças impostos está agravando as desigualdades sociais.Além de complexo e ineficiente, ele é injusto, pesando proporcionalmente mais sobre quem ganha menos.',
      },
      component: () => import('@/components/Share.vue'),
    },
    {
      path: '/calculadora',
      name: 'calculator',
      meta: {
        title: 'Calculadora | O valor do seu imposto',
        image: require('@/assets/images/home/img-home-andreteixeira.png'),
        description: 'Entenda o papel social dos impostos e porque uma reforma tributária justa é fundamental para reduzir as desigualdades brasileiras.',
      },
      component: () => import('@/components/Home/Calculator.vue'),
    },
    {
      path: '*',
      name: '404',
      component: NotFound,
    },
  ],
});

router.beforeEach((to, from, next) => {
  const titlePage = (to.meta.title) ? to.meta.title : 'O Valor do seu imposto | Oxfam Brasil';
  const imagePage = (to.meta.image) ? to.meta.image : require('@/assets/images/home/img-home-andreteixeira.png');
  const descriptionPage = (to.meta.description) ? to.meta.description : 'Entenda o papel social dos impostos e porque uma reforma tributária justa é fundamental para reduzir as desigualdades brasileiras.';

  document.title = titlePage;

  if (store.state.offcanvas.isOpen) {
    store.dispatch('offcanvas/close');
  }

  document.head.querySelector('meta[property="og:title"]').setAttribute('content', titlePage);
  document.head.querySelector('meta[property="og:image"]').setAttribute('content', imagePage);
  document.head.querySelector('meta[property="og:description"]').setAttribute('content', descriptionPage);

  window.scrollTo(0, 0);

  next();
});

router.afterEach(( to, from ) => {
  if (!window.dataLayer){
    return;
  }
  
  window.dataLayer.push({
    'event': 'content-view',
    'content-name': to.path
  })
});

export default router;
